import React, { useEffect, useState } from "react";
import {
  makeStyles,
  Theme,
  createStyles,
  Container,
  Grid,
  CardMedia,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import ReactPlayer from "react-player";
import VideoOneLayout from "../../../CitizenPageComponent/CitizenMaterial/VideosLayout/VideoOneLayout";
import VideoTwoLayout from "../../../CitizenPageComponent/CitizenMaterial/VideosLayout/VideoTwoLayout";
import VideoThreeLayout from "../../../CitizenPageComponent/CitizenMaterial/VideosLayout/VideoThreeLayout";
import VideoFourLayout from "../../../CitizenPageComponent/CitizenMaterial/VideosLayout/VideoFourLayout";

// import { stateToHTML } from "draft-js-export-html";
// import { Editor, EditorState, convertToRaw, convertFromRaw } from "draft-js";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    sectionRoot: {
      background: "white",
      // minHeight: "90vh",
      marginTop: "8%",
      marginBottom: "8%",
      //   padding: "0 4.948% 109px 4.948%",
      paddingLeft: "6rem",
      paddingRight: "6rem",
    },
    sectionRoot2: {
      background: "white",
      minHeight: "55vh",
      // marginTop: "8%",
      marginBottom: "8%",
      //   padding: "0 4.948% 109px 4.948%",
      // paddingLeft: "6rem",
      // paddingRight: "6rem",
      // paddingTop: "56.25%",
      // backgroundSize: "100%",
      // backgroundPosition: "50% 50%",
    },
    categoryText: {
      // fontFamily:"Black Han Sans"
      fontFamily: "Gothic A1",
      fontSize: 48,
      color: "black",
      fontWeight: 900,
      letterSpacing: -4,
      paddingBottom: 16,
    },
    subCategory: {
      fontFamily: "Gothic A1",
      fontSize: 40,
      color: "black",
      fontWeight: 500,
      //   paddingLeft:6
      letterSpacing: -1,
    },
    winnerDiv: {
      // paddingTop: "4rem"
    },
    winnerCategory: {
      fontSize: 20,
      fontWeight: 900,
      paddingRight: 32,
      //   color: "#7a5f50",
      color: "black",
      fontFamily: "Gothic A1",
      paddingBottom: 8,
    },
    winnerName: {
      fontSize: 20,
      fontWeight: 400,
      color: "black",
      fontFamily: "Gothic A1",
    },
    winnerTopDiv: {
      //   display: "flex",
      paddingBottom: 32,
    },
  })
);
interface ConcertMaterialProps {
  // history: History;
  urlArray: any;
}

function LaborIssueVideosLayout({ urlArray }: ConcertMaterialProps) {
  // const { history } = props;
  const theme = useTheme();
  const mdMatches = useMediaQuery(theme.breakpoints.down("md"));
  // let html = stateToHTML(contentState.getCurrentContent());

  const classes = useStyles();

  // if (urlArray && urlArray.length > 0) {
  //   if (urlArray.length == 1) {
  //     return <VideoOneLayout urlArray={urlArray} />;
  //   } else if (urlArray.length == 2) {
  //     return <VideoTwoLayout urlArray={urlArray} />;
  //   } else if (urlArray.length == 3) {
  //     return <VideoThreeLayout urlArray={urlArray} />;
  //   } else {
  //     return <VideoFourLayout urlArray={urlArray} />;
  //   }
  // } else {
  //   return <div></div>;
  // }
  if (urlArray && urlArray.length > 0) {
    if (mdMatches) {
      return <VideoOneLayout urlArray={urlArray} />;
    } else {
      if (urlArray.length == 1) {
        return <VideoOneLayout urlArray={urlArray} />;
      } else if (urlArray.length == 2) {
        return <VideoTwoLayout urlArray={urlArray} />;
      } else if (urlArray.length == 3) {
        return <VideoThreeLayout urlArray={urlArray} />;
      } else {
        return <VideoFourLayout urlArray={urlArray} />;
      }
    }
  } else {
    return <div></div>;
  }
}

export default LaborIssueVideosLayout;
